<div class="container-fluid">
  <div class="row">
    <div class="col-lg-8 login-bg vh-100"></div>
    <div
      class="col-lg-4 d-flex d-flex justify-content-center align-items-center flex-column">
      <div class="col-lg-9">
        <div class="login-logo mb-4">
          <img src="/assets/images/logo.webp" alt="Login Background" />
        </div>
        <h4 class="text-left">Account Login</h4>
        <p>
          If you are a member of Nadel Team you can login with your email
          address and password.
        </p>
        <p-button
          label="Sign in"
          class="p-button-lg p-0 w-100-size"
          (click)="loginRedirect()" />
      </div>
    </div>
  </div>
</div>
<p-toast />
